export const lifecycleStatusEnum = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  RETIRED: 'RETIRED',
} as const

export type LifecycleStatusEnum = (typeof lifecycleStatusEnum)[keyof typeof lifecycleStatusEnum]

/**
 * @description Lifecycle status for entities like assets, positions, etc.
 */
export type LifecycleStatus = LifecycleStatusEnum